import { useLocation, useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import React, { useEffect, useRef, useState } from "react";
import { list_comment, orgIdentity, organizationStepAccept, sendComment, sendCommentNew } from "../../../api/apiHandler";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import Swal from "sweetalert2";
import { TOAST_ERROR, TOAST_SUCCESS, TOAST_WARNING } from "../../../utils/common.service";
import * as Yup from "yup";
import { useFormik } from "formik";
import FileModal from "../../../components/FileModal";
import DataTable from "react-data-table-component";
import customStyles from "../../../utils/dataTableStyles";

export default function OIdentity({ isLoader }) {

    const [data, setData] = useState([])
    const [commentsList, setCommentsList] = useState([]);
    const [isCommentSent, setIsCommentSent] = useState(false);
    const navigate = useNavigate()
    const location = useLocation()
    const orgId = (location.state && location.state.oId) || new URLSearchParams(location.search).get('oId');
    const email = (location.state && location.state.email) || new URLSearchParams(location.search).get('email');
    const name = (location.state && location.state.oname) || new URLSearchParams(location.search).get('oname');

    const GetOrgIdentity = () => {
        isLoader(true)
        orgIdentity({ org_id: orgId }).then((response) => {
            console.log('response :', response);
            if (response.code == 1) {
                setData(response.data[0])
                isLoader(false)
            } else {
                setData([])
                isLoader(false)
            }
        })
    }

    const GetOrgApplicationComments = async () => {
        try {
            isLoader(true);
            const response = await list_comment({ comment_id: orgId, action_type: "600" });
            console.log('response :', response);
            if (response.code == 1) {
                const dataWithRowCount = response.data.map((row, index) => ({ ...row, count: index + 1 }));
                setCommentsList(dataWithRowCount);
            } else if (response.code == 0) {
                TOAST_ERROR(response.message);
            }
        } catch (error) {
            console.log('error :', error);
            TOAST_ERROR(error);
        } finally {
            isLoader(false);
        }
    };

    const columns = [
        {
            name: 'No',
            selector: row => row.count,
            sortable: false,
            width: "70px"
        },
        {
            name: "Date",
            selector: row => {
                const date = new Date(row.created_at);
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const formattedMonth = month < 10 ? `0${month}` : month;
                const formattedDay = day < 10 ? `0${day}` : day;
                const year = date.getFullYear();
                return `${formattedDay}-${formattedMonth}-${year}`;
            },
            sortable: true,
        },
        {
            name: "Admin name",
            selector: row => row.admin_name,
            sortable: true,
        },
        {
            name: "Comment",
            selector: row => row.comment,
            sortable: true,
        },
    ]

    useEffect(() => {
        GetOrgIdentity();
        GetOrgApplicationComments();
    }, []);

    const handleBack = () => {
        navigate(-1);
    };

    const handleAccpet = () => {
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to accept organization identity?",
            showCancelButton: true,
            confirmButtonText: "Accept",
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    var objAccept = {
                        org_id: orgId,
                        email: email,
                        accept: "2",
                        step: "2",
                        org_name: name
                    };
                    isLoader(true)
                    organizationStepAccept(objAccept).then((response) => {
                        if (response.code == 1) {
                            TOAST_SUCCESS(response.message);
                            setData(prevData => ({ ...prevData, step_2: "2" }));
                            isLoader(false)
                        } else {
                            TOAST_ERROR(response.message);
                            isLoader(false)
                        }
                    });
                } catch (error) {
                    TOAST_ERROR("Error..!!");
                }
            }
        });
    }

    const handleReject = () => {
        if (!isCommentSent) {
            TOAST_WARNING("Please send your comment first before rejecting.");
            return;
        }

        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to reject organization identity?",
            showCancelButton: true,
            confirmButtonText: "Reject",
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    var objReject = {
                        org_id: orgId,
                        email: email,
                        accept: "3",
                        step: "2",
                        org_name: name
                    };
                    isLoader(true)
                    organizationStepAccept(objReject).then((response) => {
                        if (response.code == 1) {
                            TOAST_SUCCESS(response.message);
                            setData(prevData => ({ ...prevData, step_2: "3" }));
                            setIsCommentSent(false);
                            isLoader(false)
                        } else {
                            TOAST_ERROR(response.message);
                            isLoader(false)
                        }
                    });
                } catch (error) {
                    TOAST_ERROR("Error..!!");
                }
            }
        });
    }

    const fileInputs = useRef([]);
    const resetFileInputs = () => {
        fileInputs.current.forEach((input) => {
            input.value = '';
        });
    };

    const commentSchema = Yup.object({
        comment: Yup.string()
    });

    const commentForm = useFormik({
        initialValues: {
            comment: '',
        },
        validationSchema: commentSchema,

        onSubmit: async (commentData) => {
            if (commentData.comment.trim() != "") {
                commentData.action_id = data.id
                commentData.action_type = "600"
                commentData.id = orgId;
                commentData.email = email;
                commentData.comment_for = 2; //comment_for 1 = teacher , 2 = organization , 3 = organization_teacher
                commentData.step = 2;
                commentData.name = name
                isLoader(true)
                sendCommentNew(commentData).then((response) => {
                    if (response.code == 1) {
                        TOAST_SUCCESS(response.message);
                        commentForm.resetForm();
                        resetFileInputs();
                        setIsCommentSent(true);
                        GetOrgIdentity();
                        GetOrgApplicationComments();
                        isLoader(false)
                    } else {
                        TOAST_ERROR(response.message);
                        isLoader(false)
                    }
                });
            }
        },
    });

    const displayError = (fieldName) =>
        commentForm.touched[fieldName] && commentForm.errors[fieldName];

    const [selectedFile, setSelectedFile] = useState(null);
    const [docModal, setDocModal] = useState(false);

    const openModal = (url) => {
        setSelectedFile(url);
        setDocModal(true);
    };

    const closeModal = () => {
        setSelectedFile(null);
        setDocModal(false);
    };

    return <>
        <JqueryLoad />
        <Hdashboard />
        <header className="dashboard-toolbar d-lg-flex justify-content-between">
            <div className="align-items-center justify-content-between d-flex">
                <div className="d-flex align-items-center">
                    <a className="menu-toggle align-items-center d-lg-none d-flex">
                        <i className="fa fa-bars" />
                    </a>
                    <a href="index.php" className="d-lg-none d-block brand-logo">
                        <img src="./assets/images/logo.png" alt="logo" />
                    </a>
                </div>
            </div>
        </header>
        <section className="main_sec">
            <div className="mt-4 mx-5 mb-5">
                <div>
                    <span onClick={handleBack}>
                        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" ></path>
                        </svg>
                        <span className="ms-2">Back</span>
                    </span>
                </div>

                {(Object.keys(data).length > 0 ? (
                    <>
                        <p className="ms-3 fs-3 fw-500 text-center mb-3">Organization Identity Verification</p>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col col-lg-8 mb-4 mb-lg-0">
                                <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                    <div className="row g-0">
                                        <div className="col-md-12">
                                            <div className="card-body p-4">
                                                <p className="mb-2 fs-5 fw-600">Information</p>
                                                <hr className="mt-0 mb-4" />
                                                <div className="row pt-1">
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-600">What is your full legal name</p>
                                                        <p className="text-muted mt-1">{data.org_legal_name}</p>
                                                    </div>
                                                    <p className="fw-600 my-2">What Is Your Address? Your Address Should Be The Same As Shown In Your Government Identification That You Will Be Submitting Below.</p>
                                                    <div className="col-5 mb-4">
                                                        <p className="fw-600">Street Number</p>
                                                        <p className="text-muted mt-1">{data.street_number}</p>
                                                    </div>
                                                    <div className="col-5 mb-4">
                                                        <p className="fw-600">Street Name</p>
                                                        <p className="text-muted mt-1">{data.street_name}</p>
                                                    </div>
                                                    <div className="col-5 mb-4">
                                                        <p className="fw-600">Country</p>
                                                        <p className="text-muted mt-1">{data.country_name}</p>
                                                    </div>
                                                    <div className="col-5 mb-4">
                                                        <p className="fw-600">Province/State</p>
                                                        <p className="text-muted mt-1">{data.state_province_name}</p>
                                                    </div>
                                                    <div className="col-5 mb-4">
                                                        <p className="fw-600">City</p>
                                                        <p className="text-muted mt-1">{data.city}</p>
                                                    </div>
                                                    <div className="col-5 mb-4">
                                                        <p className="fw-600">Zip Code</p>
                                                        <p className="text-muted mt-1">{data.zip_code}</p>
                                                    </div>
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-600">Upload A Selfie Of Yourself. You Should Clearly Show Your Face</p>
                                                        {/* {data.selfie_picture && (
                                                            <a href={data.selfie_picture} className="text-purple underline mt-1">View Selfie</a>
                                                        )} */}
                                                        {data.selfie_picture && (
                                                            <a onClick={() => openModal(data.selfie_picture)} className="text-purple underline mt-1">View Selfie</a>
                                                        )}
                                                    </div>
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-600">What Type Of Government ID Will You Upload To Verify Your Identity? The ID Should Have Your Picture. </p>
                                                        <p className="text-muted mt-1">{data.org_doc_name}</p>
                                                    </div>

                                                    <div className="col-12 mb-4">
                                                        <p className="fw-600">Id Proof Attachment</p>
                                                        {data.teacher_document && data.teacher_document.length > 0 ? (
                                                            data.teacher_document.map((doc, index) => (
                                                                <a
                                                                    key={doc.id}
                                                                    // href={doc.teacher_certificate}
                                                                    onClick={() => openModal(doc.teacher_certificate)}
                                                                    className="text-purple underline mt-1 d-block"
                                                                // target="_blank"
                                                                // rel="noopener noreferrer"
                                                                >
                                                                    View Attachment {index + 1}
                                                                </a>
                                                            ))
                                                        ) : (
                                                            <p>No documents available</p>
                                                        )}
                                                    </div>

                                                    <div className="col-4 mb-4">
                                                        <p className="fw-500">Full Name</p>
                                                        <p className="text-muted mt-1">{data.full_name}</p>
                                                    </div>

                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">Your Country of Residence :</p>
                                                        <p className="text-muted mt-1">{data.country_residence}</p>
                                                    </div>

                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">Date : </p>
                                                        <p className="text-muted mt-1">
                                                            {new Date(data.updated_at).toLocaleDateString('en-GB')}
                                                        </p>
                                                    </div>

                                                    {/* <div className="col-12 mb-4">
                                                        <p className="fw-500">Admin Comments</p>
                                                        <p className="text-muted mt-1">{data.comments}</p>
                                                    </div> */}
                                                </div>

                                                <form className="custom_form mt-4" name="commentForm" onSubmit={commentForm.handleSubmit}>

                                                    <div className="form-group mb-4">
                                                        <p className="fw-500 mb-2">Any comments you have, please add them here for the teacher.</p>
                                                        <textarea type="text" className="form-control" name="comment" value={commentForm.values.comment} rows="5" cols="33" onChange={commentForm.handleChange} ></textarea>
                                                        {displayError("comment") && (
                                                            <div className="text-danger">{commentForm.errors.comment}</div>
                                                        )}
                                                        <div className="button mt-2 mb-2 d-flex justify-content-end">
                                                            <button type="submit" className="btn-theme px-4 py-2  text-center text-dif-black fw-500 bg-yellow mb-xl-0 mb-3 d-inline-block">Send</button>
                                                        </div>
                                                    </div>
                                                </form>
                                                {(data.step_2 == 0 || data.step_2 == 1) &&

                                                    <div className="d-flex justify-content-center mt-3">
                                                        <button className="btn-theme bg-yellow mx-1" onClick={() => handleAccpet()}>
                                                            {data.step_2 == "2" ? "Accepted" : "Accept"}
                                                        </button>
                                                        <button className="btn-theme mx-1" onClick={() => handleReject()}>
                                                            {data.step_2 == "3" ? "Rejected" : "Reject"}
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {commentsList?.length > 0 && (
                                    <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                        <div className="row g-0">
                                            <div className="col-md-12">
                                                <div className="card-body p-4">
                                                    <DataTable
                                                        persistTableHead
                                                        columns={columns}
                                                        data={commentsList}
                                                        pagination
                                                        customStyles={customStyles}
                                                        className="custom-data-table"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                ) : (
                    <div>
                        <p className="text-center fs-5 fw-500 text-danger mt-5">The Organization has not filled out the identity form.</p>
                    </div>
                )
                )}
            </div>
        </section>

        {docModal && <FileModal isOpen={docModal} fileUrl={selectedFile} onClose={closeModal} />}
    </>
}

